var _path, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPluginPlaceholder = function SvgPluginPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    fill: "none",
    viewBox: "0 0 250 250"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9D5FC",
    d: "M0 0h250v250H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 156,
    x: 47,
    y: 47,
    fill: "#902EEF",
    rx: 78
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M105 79.865a4 4 0 0 1 4 4v29.792h32V83.865a4 4 0 0 1 8 0v29.792h9.279a4 4 0 0 1 4 4v23.296c0 19.568-15.077 35.615-34.248 37.158v42.754a4 4 0 0 1-8 0v-42.96c-18.24-2.429-32.312-18.047-32.312-36.952v-23.296a4 4 0 0 1 4-4H101V83.865a4 4 0 0 1 4-4m-9.281 41.792v19.296c0 16.171 13.109 29.28 29.28 29.28s29.28-13.109 29.28-29.28v-19.296z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47 47h156v156H47z"
  })))));
};
export default SvgPluginPlaceholder;